import { parseQueryParams, stringifyQueryParams } from "components/common";

export const parsePage = ({ pageName = "page", normalizePage = page => parseInt(page, 10) - 1, ...props }) => {
  return parseParam({ paramName: pageName, normalize: normalizePage, ...props });
};

export const parseParam = ({ queryParams, paramName = "page", normalize = param => parseInt(param, 10) - 1 }) => {
  const param = parseQueryParams(queryParams)[paramName];
  return param ? normalize(param) : null;
};

export const onChangePage = ({ pageName = "page", page, normalizePage = page => parseInt(page, 10) + 1, ...props }) =>
  onChangeParam({ paramName: pageName, paramValue: page, normalize: normalizePage, ...props });

export const onChangeParam = ({
  paramName = "page",
  paramValue,
  normalize = index => parseInt(index, 10) + 1,
  query,
  history,
}) => {
  const newQueryParams = {
    ...parseQueryParams(query),
    [paramName]: normalize(paramValue),
  };
  history.push(location.pathname + "?" + stringifyQueryParams(newQueryParams));
};

export const onChangeParams = ({ paramsObject, query, history }) => {
  const newQueryParams = {
    ...parseQueryParams(query),
    ...paramsObject,
  };
  history.push(location.pathname + "?" + stringifyQueryParams(newQueryParams));
};

export const parseParams = ({ queryParams }) => {
  return parseQueryParams(queryParams);
};
